export const CUtext = {
     description:"Kelster Mania is here to help you win! Please fill out the form below to get in touch with our team and we will get back to you within 3-5 business days. Be sure to follow us on Social Media for the latest updates.",
    addressLine1: "Kelster Mania",
    addressLine2: "1739-246 Stewart Green SW",
    addressLine3: "Calgary, AB",
    addressLine4: "T3H 3C8",
};
  export default CUtext;
  